import ReactDOM from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import App from './App';
import { createCspSafeEmotionCache, installCspSafeInlineStyles } from './lib/csp';

installCspSafeInlineStyles();
const emotionCache = createCspSafeEmotionCache();

ReactDOM.createRoot(document.getElementById('root')!).render(
  // Disabled StrictMode to prevent double renders causing duplicate requests
  // Re-enable after fixing duplicate request issues
  <CacheProvider value={emotionCache}>
    <App />
  </CacheProvider>
);
